import React from "react";
import "./skills.css";

const Skills = () => {
  return (
    <section className="skills section" id="skills">
      <h2 className="section__title section__title--highlight">
      My Skills
      </h2>
      <span className="section__subtitle">
        Core technical skills and tools
      </span>

      <div className="skills__container container">

        <div className="skills__category">
          <h3 className="skills__category-title">Backend Development</h3>
          <ul className="skills__list">
            <li>Java</li>
            <li>JDBC</li>
            <li>Servlets</li>
            <li>MySQL</li>
          </ul>
        </div>

        <div className="skills__category">
          <h3 className="skills__category-title">Frameworks</h3>
          <ul className="skills__list">
            <li>Spring Framework</li>
            <li>Spring MVC</li>
            <li>Spring Boot</li>
          </ul>
        </div>

        <div className="skills__category">
          <h3 className="skills__category-title">Frontend Development</h3>
          <ul className="skills__list">
            <li>HTML5</li>
            <li>CSS3</li>
            <li>JavaScript</li>
            <li>React.js</li>
          </ul>
        </div>

        <div className="skills__category">
          <h3 className="skills__category-title">Core Concepts</h3>
          <ul className="skills__list">
            <li>Object-Oriented Programming (OOP)</li>
            <li>Multi-Threading</li>
            <li>Exception Handling</li>
          </ul>
        </div>

        <div className="skills__category">
          <h3 className="skills__category-title">Tools & Others</h3>
          <ul className="skills__list">
            <li>Eclipse</li>
            <li>VS Code</li>
            <li>Git & GitHub</li>
          </ul>
        </div>

      </div>
    </section>
  );
};

export default Skills;
